import React, { useEffect } from 'react';
import { useSharedData } from '../Contexts/SharedContext';
import { useTheme } from '../Contexts/ThemeContext';
import { useLanguage } from '../Contexts/LanguageContext';
import { getTranslatedValue } from '../Utils/getTranslatedText';

import strings from '../strings';

import Header from '../Components/Header/Header';
import Footer from '../Components/Footer/Footer';
import StartPageMenu from '../Components/StartPageMenu';
import Logo from '../Elements/Icon/assets/logo.component.svg';
import ExhibitionTeaser from '../Components/ExhibitionTeaser';
import { Paragraph } from '../Elements/Paragraph';

const StartPage = () => {
    const { content, loading, error } = useSharedData();
    const { setTheme} = useTheme();
    const { language } = useLanguage();
        
    useEffect(() => {
        setTheme('');
    }, [setTheme]);

    if (!content) {
        return null;
    }

    const startPageText = getTranslatedValue(content?.startPageText?.text ?? null, language);
    const teaserTitle = getTranslatedValue(content?.startPageTeaser?.title ?? null, language);
    const openingHours = content?.openingHours || strings.OPENING_HOURS[language].CLOSED;

    return (
        <>
            <Header />
            <div className="start-page">
                <div className="start-page__header">
                    <p className="heading-small start-page__header__text">{strings.STARTPAGE_TITLE[language]}</p>
                    <h1 className="visually-hidden">Nordiska museet</h1>
                    <Logo />
                </div>
                <StartPageMenu language={language} />
                <div className="start-page__opening-hours">
                    <h2 className="heading-mini start-page__opening-hours__title">{strings.OPENING_HOURS[language].LABEL}:</h2>
                    <p className="heading-mega start-page__opening-hours__hours">{openingHours}</p>
                </div>
                <div className="start-page__content">
                    <Paragraph text={ startPageText } alignCenter />
                    <ExhibitionTeaser 
                        image={ content?.startPageTeaser?.image ?? null }
                        text={ teaserTitle } 
                        targetUrl="/guides"
                        withArrow
                    />
                </div>
            </div>
            <Footer />
        </>
    );
}

export default StartPage;